import MuiClose from '@mui/icons-material/Close';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type CloseProps = SvgIconProps;

export const Close = (props: CloseProps) => {
  return <MuiClose {...props} />;
};
